export const SHOW_ODOM = 'SHOW_ODOM';
export const HIDE_ODOM = 'HIDE_ODOM';
export const CHECK_ODOM = 'CHECK_ODOM';
export const RESET_ODOM = 'RESET_ODOM';
export const SAVING_DATA = 'SAVING_DATA';
export const CHECKING_ODOM = 'CHECKING_ODOM';
